import { handleActions } from 'redux-actions';

interface RoutePayload {
    location: {
        pathname: string;
        search: string;
    };
    slideCount: number;
}

interface State {
    slide: number | null;
    params: string[];
}


const reducer = handleActions<State, RoutePayload>(
    {
        UPDATE_ROUTE: (state, action) => {
            const { location, slideCount } = action.payload;
            const slideHash = location.pathname.replace(/\//g, '');
            let slide;

            if (isNaN(parseInt(slide, 10))) {
                slide = slideHash;
            } else {
                const proposedSlideIndex = parseInt(
                    location.pathname.replace(/\//g, ''),
                    10,
                );
                const isWithinBounds = proposedSlideIndex < slideCount && proposedSlideIndex >= 0;
                slide = isWithinBounds ? proposedSlideIndex : 0;
            }

            return {
                slide,
                params: location.search.replace('?', '').split('&'),
            };
        },
        RESET_ROUTE: () => ({ slide: null, params: [] }),
    },
    { slide: null, params: [] },
);

export default reducer;
